export function randInt(min: number, max: number) {
	return Math.floor(Math.random() * (max - min + 1)) + min
}

export function randElement(arr: any[]) {
	return arr[randInt(0, arr.length - 1)]
}

export function initialCap(s: string) {
	return s[0].toUpperCase() + s.substr(1)
}
